import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated, isAuthLoading, checkAuthStatus } from '../api/auth';

const PrivateRoute = ({ children }) => {
  const location = useLocation();
  const [authState, setAuthState] = useState({
    isAuthenticated: isAuthenticated(),
    isLoading: isAuthLoading()
  });

  useEffect(() => {
    // Initialize auth state
    const init = async () => {
      try {
        await checkAuthStatus();
      } catch (error) {
        console.error('Failed to check auth status:', error);
      }
    };
    init();

    const handleAuthChange = (event) => {
      setAuthState({
        isAuthenticated: event.detail.isAuthenticated,
        isLoading: event.detail.isLoading
      });
    };

    window.addEventListener('auth-state-change', handleAuthChange);
    return () => window.removeEventListener('auth-state-change', handleAuthChange);
  }, []);

  if (authState.isLoading) {
    return null;
  }
  
  return authState.isAuthenticated ? children : <Navigate to="/login" state={{ from: location }} replace />;
};

export default PrivateRoute;
